import React from 'react';
import styled from '@emotion/styled';
import { Colors, Link } from '@zapier/design-system';

const spaceId = process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID;

type Props = {
  handleHideBanner: () => void;
  articleId?: string;
};

export const EditPostBanner = ({ handleHideBanner, articleId }: Props) => {
  const href = `https://app.contentful.com/spaces/${spaceId}/entries/${articleId}`;

  return (
    <Outer>
      <Link href={href} target="_blank">
        Edit post
      </Link>
      <Delimiter>/</Delimiter>
      <Hide onClick={handleHideBanner}>Hide this</Hide>
    </Outer>
  );
};

const Outer = styled.div`
  display: flex;
  justify-content: center;
  font-size: 15px;
  padding: 10px 15px;
  background-color: ${Colors.gray5};
`;

const Delimiter = styled.p`
  margin: 0px 5px;
`;

const Hide = styled.p`
  cursor: pointer;
`;
